import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import MealOptions from './MealOptions';
import Quantity from '../../components/Quantity/Quantity';
import Price from '../Price/Price';
import {
  Wrapper,
  Title,
  Subtitle,
  ButtonsHolder,
  MealDescription,
  AddToBasket,
  Header,
  Content,
  Comments,
  PriceTag,
  Cancel,
  QuantityWrapper
} from './BasketModalItem.style';
import {ANALYTICS_EC, BASKET_MODE, PROMOTION_TYPES} from '../../constants/constant';
import {FormattedMessage} from 'react-intl';
import {GoogleAnalyticsHelper} from '../../helpers/googleAnalytics.helper';

export class BasketModalItem extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      itemQuantity: this.props.basketItem.quantity
    };
    this.updateBasketItem = this.updateBasketItem.bind(this);
    this.updateComments = this.updateComments.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return this.props.basketItem.price !== nextProps.mealPrice;
  }

  updateBasketItem() {
    const {updateBasket, cancel, basketItem, meal} = this.props;
    updateBasket(basketItem.uuid, basketItem.origin);

    if (this.state.itemQuantity !== basketItem.quantity || !basketItem.uuid) {
      GoogleAnalyticsHelper.trackMeal(
        this.state.itemQuantity <= basketItem.quantity ? ANALYTICS_EC.EC_ADD_ACTION : ANALYTICS_EC.EC_REMOVE_ACTION,
        {
          id: basketItem.mealUuid,
          name: meal.name,
          price: meal.price.toString(),
          quantity: basketItem.quantity ? basketItem.quantity : 1,
          category: meal.categoryName || ''
        },
        basketItem.origin
      );
    }

    cancel();
  }

  updateComments(e) {
    this.props.updateItemComments(e.target.value);
  }

  render() {
    const {meal, cancel, updateQuantity, basketItem, restaurantModes, isOfflineMenu, serverOffline} = this.props;
    const {price, quantity} = basketItem;
    let selectedSizeIndex = 0;
    if (basketItem.size && meal && meal.sizes) {
      const checkSizeIndex = meal.sizes.findIndex(size => size.name === basketItem.size);
      selectedSizeIndex = checkSizeIndex > -1 ? checkSizeIndex : 0;
    }
    const basketModalMode = basketItem.uuid ? BASKET_MODE.EDIT : BASKET_MODE.CREATE;

    const renderMealOption = meal.sizes.length &&
      <MealOptions
        sizes={meal.sizes}
        selectedOptions={basketItem.selectedOptions}
        basketItemUuid={basketItem.uuid}
        basketModalMode={basketModalMode}
        selectedSizeIndex={selectedSizeIndex}
      />;

    const initialQuantity = quantity || 1;
    const minValue = 1;
    const isFreeMeal = basketItem.promotion && basketItem.promotion.applied && basketItem.promotion.type === PROMOTION_TYPES.FREE_MEAL;

    const renderButtons = (<ButtonsHolder>
      {
        basketModalMode === BASKET_MODE.EDIT && restaurantModes.onlineOrdering && !isOfflineMenu && !isFreeMeal && !serverOffline &&
        <QuantityWrapper>
          <Quantity
            defaultValue={initialQuantity}
            minValue={minValue}
            updateValue={updateQuantity}
          />
        </QuantityWrapper>
      }
      <Cancel onClick={cancel}><FormattedMessage id={basketItem.uuid ? 'basket.close' : 'basket.cancel'} /></Cancel>
      {
        restaurantModes.onlineOrdering && !isOfflineMenu && !serverOffline &&
        <AddToBasket
          onClick={this.updateBasketItem}
          data-rw="basket-modal--add-to-basket-button"
        >
          { basketModalMode === BASKET_MODE.CREATE ? 'add to basket' : 'update basket'}
          <PriceTag data-rw="basket-modal--add-to-basket-button--price"><Price amount={price} /></PriceTag>
        </AddToBasket>
      }
    </ButtonsHolder>);

    return (
      <Wrapper data-rw="basket-modal--component">
        <Header>
          <Title data-rw="basket-modal--meal-title">{meal.name}</Title>
          <MealDescription data-rw="basket-modal--meal-description">{meal.description}</MealDescription>
        </Header>
        <Content>
          {renderMealOption}
          <Subtitle>
            <FormattedMessage id="basket.specialInstructions" />
          </Subtitle>
          <Comments
            type="text"
            value={basketItem.comments}
            onChange={this.updateComments}
            placeholder="Type here..."
            maxLength="256"
            data-rw="basket-modal--special-instructions"
          />
        </Content>
        {renderButtons}
      </Wrapper>
    );
  }
}

BasketModalItem.propTypes = {
  meal: PropTypes.object.isRequired,
  updateBasket: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  updateQuantity: PropTypes.func.isRequired,
  updateItemComments: PropTypes.func.isRequired,
  basketItem: PropTypes.object,
  restaurantModes: PropTypes.object.isRequired,
  isOfflineMenu: PropTypes.bool.isRequired,
  serverOffline: PropTypes.bool.isRequired
};

export default BasketModalItem;




// WEBPACK FOOTER //
// ./components/Meal/BasketModalItem.js